var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppStore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "appstore 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.177 9.60298C14.157 7.89798 15.569 7.05399 15.647 7.01399C14.843 5.83699 13.608 5.68099 13.177 5.68099C12.138 5.56399 11.118 6.30899 10.588 6.30899C10.039 6.30899 9.235 5.70099 8.353 5.72099C7.217 5.73999 6.159 6.38699 5.57 7.40599C4.374 9.48399 5.257 12.543 6.413 14.23C6.982 15.053 7.668 15.974 8.55 15.935C9.412 15.896 9.727 15.386 10.765 15.386C11.803 15.386 12.098 15.935 13 15.916C13.921 15.896 14.51 15.093 15.059 14.25C15.726 13.309 16 12.367 16 12.327C15.962 12.329 14.177 11.662 14.177 9.60298Z",
    fill: "#858894"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.158 2.40799C12.491 2.44699 11.648 2.87899 11.158 3.44699C10.726 3.93799 10.354 4.76099 10.452 5.52499C11.217 5.58399 11.981 5.15299 12.472 4.58399C12.943 3.99599 13.256 3.21099 13.158 2.40799Z",
    fill: "#858894"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStore);
export default __webpack_public_path__ + "static/media/app-store.e8c46ed9c5c5bba5a3332c7d8aafc858.svg";
export { ForwardRef as ReactComponent };